"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupBase = void 0;
var react_1 = __importDefault(require("react"));
var PopupBase = /** @class */ (function (_super) {
    __extends(PopupBase, _super);
    function PopupBase(props) {
        var _this = _super.call(this, props) || this;
        _this.handleEscPress = _this.handleEscPress.bind(_this);
        _this.popupRef = react_1.default.createRef();
        return _this;
    }
    PopupBase.prototype.render = function () {
        var _a = this.props, children = _a.children, _b = _a.overlay, overlay = _b === void 0 ? true : _b;
        return (react_1.default.createElement("div", { onKeyDown: this.handleEscPress, tabIndex: 0, ref: this.popupRef, className: "PopupBase absolute w-full top-0 left-0 h-full flex justify-center items-center" },
            react_1.default.createElement("div", { className: "PopupOverlay absolute top-0 left-0 w-full h-full cursor-pointer ".concat(overlay ? "opacity-75 bg-grey-darkest" : ""), style: this.props.overlayStyle, onClick: this.props.onClose }),
            react_1.default.createElement("div", { className: "PopupWrapper PopupWrapper-".concat(this.props.position, " opacity-100 bg-white absolute \n          shadow-md overflow-y-auto overflow-x-hidden"), style: this.props.wrapperStyle }, children)));
    };
    PopupBase.prototype.componentDidMount = function () {
        this.popupRef.current.focus();
    };
    PopupBase.prototype.handleEscPress = function (event) {
        if (event.key === "Escape" && this.props.onClose) {
            this.props.onClose();
            event.stopPropagation();
        }
    };
    PopupBase.Props = {
        position: "center",
    };
    return PopupBase;
}(react_1.default.Component));
exports.PopupBase = PopupBase;
